import type { Targeting } from '@openx/types/targeting/targeting.ts';

export type PackageListTargetingValues = {
  ad_placement: string | null;
  device_type: string | null;
  distribution_channel: string | null;
};

export const getPackageListTargetingValues = (targeting?: Targeting): PackageListTargetingValues => {
  const desktopDevices = targeting?.rendering_context?.device_type?.desktop_devices;
  const mobileDevices = targeting?.rendering_context?.device_type?.mobile_devices;
  const tvDevices = targeting?.rendering_context?.device_type?.tv_devices;

  const renderingContextDevices = [desktopDevices, mobileDevices, tvDevices].filter(Boolean).join(',');

  return {
    ad_placement:
      targeting?.rendering_context?.ad_placement?.val || targeting?.inventory_format?.ad_placement?.val || null,

    device_type: renderingContextDevices || targeting?.technographic?.device_type?.val || null,

    distribution_channel:
      targeting?.rendering_context?.distribution_channel?.val ||
      targeting?.inventory_format?.distribution_channel?.val ||
      null,
  };
};
